import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  sendListTesScores,
  getDetailTesScores,
  getListTesScores,
} from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import MSyncScoreForm from './MSyncScoreForm';
import { uniqueValueObject } from '../../../app/common/helpers/objectHelpers';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';

const mapState = (state, ownProps) => {
  return {
    detailScores: state.tess.detailScores,
    listScores: state.tess.listScores,
    studentAnswer: state.tess.studentAnswer,
  };
};

const actions = {
  closeModal,
  getDetailTesScores,
  getListTesScores,
  sendListTesScores,
};

function ModalSyncScore(props) {
  const {
    data,
    closeModal,
    detailScores,
    listScores,
    studentAnswer,
    getDetailTesScores,
    getListTesScores,
    sendListTesScores,
  } = props;
  const auth = data?.auth;
  const history = data?.history;
  const id = data?.id;
  const item = data?.item;
  const scores = item?.scores;
  const screenWidth = useScreenWidth();

  let uniqueKelas = uniqueValueObject(studentAnswer, 'kelas');
  let optionKelas = [];
  for (let i = 0; i < uniqueKelas.length; i++) {
    const item = uniqueKelas[i];
    let newItem = {
      key: item,
      text: item,
      value: item,
    };
    optionKelas = [...optionKelas, newItem];
  }

  useEffect(() => {
    let newValues = {
      ...item,
      kelas: uniqueKelas[0],
    };
    getDetailTesScores(auth, history, id, newValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      variant='info'
      label='Sync Nilai'
      closeModal={closeModal}
      width={screenWidth > 800 ? 800 : screenWidth}
    >
      <MSyncScoreForm
        id={id}
        auth={auth}
        history={history}
        item={item}
        scores={scores}
        detailScores={detailScores}
        listScores={listScores}
        getDetailTesScores={getDetailTesScores}
        getListTesScores={getListTesScores}
        optionKelas={optionKelas}
        sendListTesScores={sendListTesScores}
        closeModal={closeModal}
      />
    </Modal>
  );
}


export default connect(mapState, actions)(ModalSyncScore);
